namespace $ {
	export function $hyoo_crus_log( this: $ ) {
		return this.$mol_state_arg.value( 'hyoo_crus_log' ) !== null
	}
}
